import { Component, Input, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { Subscription, Subject } from "rxjs";
import { auditTime } from "rxjs/operators";
import { PlanificadorService } from "../control.service";
import { CdkTableVirtualScrollDataSource, TableVirtualScrollDataSource, TableVirtualScrollModule } from "ng-table-virtual-scroll";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { valorliquidativointerface } from "src/app/interface/ValorLiquidativoInterface";
import { valorlatenteinterface } from "src/app/interface/ValorLatenteInterface";
import { TableColmuns } from "src/app/interface/TableColumnsinterface";
import { DiversificadorService } from "src/app/services/diversificador.services";
import { GestionService } from "src/app/services/gestion.services";
import { BrokerService } from "src/app/services/broker.services";
import { MarketDataService } from "src/app/services/market-data.service";

@Component({
  selector: 'app-liquidating-values',
  templateUrl: './liquidating-values.component.html',
  styleUrls: ['./liquidating-values.component..scss'],
})
export class LiquidatingValuesComponent implements OnInit, OnDestroy {

public  panelOpenState: boolean =false;
colPanelOpen = false;
expandirColPanel() { this.colPanelOpen = true; }
contraerColPanel() { this.colPanelOpen = false; }
@Input() selectedTab: number =0;
@Input() loading: boolean = false;
@Input() modelo: boolean = false;
@Input() isPlanificador: boolean = false;
@Input() isGestion: boolean = false;
@Input() isBroker: boolean = false;

@ViewChild(CdkVirtualScrollViewport, { static: false })  viewportLiqVal!: CdkVirtualScrollViewport;
@ViewChild(CdkVirtualScrollViewport, { static: false })  viewportValLat!: CdkVirtualScrollViewport;
@ViewChild(CdkVirtualScrollViewport, { static: false })  viewportLiqValDiv!: CdkVirtualScrollViewport;
@ViewChild(CdkVirtualScrollViewport, { static: false })  viewportLiqValGest!: CdkVirtualScrollViewport;
@ViewChild(CdkVirtualScrollViewport, { static: false })  viewportLiqValBrok!: CdkVirtualScrollViewport;

  /* TRAER VALORES LIQUIDATIVOS */
  combinedData: any[] = [];
  public dataVal: any []=[];
  private valoresliqsubscription: Subscription;
  private divvaloresliqsubscription: Subscription;
  public fechaSubcription =  new Subscription;
  public divfechaSubcription= new Subscription;
  public gestFechaSubcription =  new Subscription;
  public gestLiqValSub = new Subscription;
  public brokFechaSubcription =  new Subscription;
  public brokLiqValSub = new Subscription;
  currentDate: string;

  public liqval = new CdkTableVirtualScrollDataSource<valorliquidativointerface>();
  public Divliqval = new CdkTableVirtualScrollDataSource<valorliquidativointerface>();
  public ValLat = new CdkTableVirtualScrollDataSource<valorlatenteinterface>();
  public gestLiqval = new CdkTableVirtualScrollDataSource<valorliquidativointerface>();
  public brokLiqval = new CdkTableVirtualScrollDataSource<valorliquidativointerface>();

    @ViewChild(MatPaginator) paginator: MatPaginator;
    //public liqvalsubcription$ : Subscription;
    public index: any;
    public indexDiv: any;
    public indexGest: any;
    public indexBrok: any;
  filaSeleccionada: any;
  contadorFilas: number;
    


    constructor(public controlService: PlanificadorService,
                public diversificadorsv: DiversificadorService,
                public _gestorsv: GestionService,
                public _brokersv: BrokerService, private marketDataService: MarketDataService
      ) {

    }
    //VALORES LIQUIDATIVOS
    tableColumns : TableColmuns []=[//
        {id: 'ncompanias', name:'N° Compañias', isShow: true, isDate: false, isNumber: false, isString: true},
        {id: 'numlineas', name:'N° Intervalos', isShow: false, isDate: false, isNumber: false, isString: true},
        {id: 'fechavalor', name:'Fecha', isShow: true, isDate: true, isNumber: false, isString: false},
        {id: 'beneficioperdida', name:'Ventas', isShow: false, isDate: false, isNumber: true, isString: false},
        {id: 'beneficioacumulado', name:'Beneficio Acumulado', isShow: true, isDate: false, isNumber: true, isString: false},
        {id: 'valorlatente', name:'Valor Latente', isShow: true, isDate: false, isNumber: true, isString: false},
        {id: 'comision', name:'comision', isShow: true, isDate: false, isNumber: true, isString: false},
        {id: 'efectivo', name:'Efectivo', isShow: true, isDate: false, isNumber: true, isString: false},
        {id: 'gastosPrestamo', name:'Gasto Prestamo', isShow: false, isDate: false, isNumber: true, isString: false},
        {id: 'gastosPrestamoAcumulado', name:'Acumulado G. Prestamo', isShow: true, isDate: false, isNumber: true, isString: false},
        {id: 'gastosGestion', name:'Gasto Gestion', isShow: false, isDate: false, isNumber: true, isString: false},
        {id: 'gastosGestionAcumulado', name:'Acumulado G Gestion', isShow: true, isDate: false, isNumber: true, isString: false},
        {id: 'swap', name:'Swap', isShow: false, isDate: false, isNumber: true, isString: false},
        {id: 'swapAcumulado', name:'Acumulado Swap', isShow: false, isDate: false, isNumber: true, isString: false},
        {id: 'valorliquidativo', name:'Valor Liquidativos', isShow: true, isDate: false, isNumber: true, isString: false},
        {id: 'valorliquidativoporcentual', name:'Acumulado V.L. %', isShow: false, isDate: false, isNumber: true, isString: false},
        {id: 'intervalosinnuevomaximo', name:'Intervalos Sin Maximo', isShow: true, isDate: false, isNumber: true, isString: false},
        {id: 'retrocesodesdemaximos', name:'Retroceso', isShow: true, isDate: false, isNumber: true, isString: false},
        {id: 'porcentajeretrocesodesdemaximo', name:'Retroceso %', isShow: false, isDate: false, isNumber: true, isString: false},
        {id: 'retrocesodesdemaximosdiario', name:'Retroceso diario', isShow: true, isDate: false, isNumber: true, isString: false},
        {id: 'porcentajeretrocesodesdemaximodiario', name:'Retroceso % diario', isShow: false, isDate: false, isNumber: true, isString: false},
        
        ];
    
        tableColumnsLat : TableColmuns []=[
          {id: 'numlinea', name:'N° Compañias', isShow: true, isDate: false, isNumber: false, isString: true},
          {id: 'fechaentrada', name:'Fecha Entrada', isShow: true, isDate: true, isNumber: false, isString: false},
          {id: 'cartera', name:'Modelo', isShow: false, isDate:false, isNumber: false, isString: true},
          {id: 'compania', name:'Compañia', isShow: true, isDate: false, isNumber: false, isString: true},
          {id: 'isooper', name:'ID', isShow: true, isDate: false, isNumber: false, isString: true},
          {id: 'precioentrada', name:'Entrada', isShow: true, isDate: false, isNumber: true, isString: false},
          {id: 'cantidadacciones', name:'N° Acciones', isShow: false, isDate: false, isNumber: true, isString: false},
          {id: 'fechaintervalo', name:'Fecha Valor', isShow: true, isDate: true, isNumber: false, isString: false},//con esto filtro
          {id: 'fechainicialintervalo', name:'Fecha', isShow: true, isDate: true, isNumber: false, isString: false},//con esto filtro
          {id: 'preciocierre', name:'Valor Cotizacion', isShow: true, isDate: false, isNumber: true, isString: false},
          {id: 'valorlatente', name:'Valor Latente', isShow: true, isDate: false, isNumber: true, isString: false},
          {id: 'bajista', name:'bajista', isShow: true, isDate: false, isNumber: false, isString: true},
        //  {id: 'filasumatorio', name:'filasumatorio', isShow: false, isDate: false, isNumber: false, isString: true},
        //  {id: 'contador', name:'N° Compañias', isShow: true, isDate: false, isNumber: false, isString: true},
         // {id: 'estado', name:'estado', isShow: false, isDate: false, isNumber: false, isString: true},
     //     {id: 'isooper', name:'ID', isShow: true, isDate: false, isNumber: false, isString: true},
        //  {id: 'secType', name:'secType', isShow: false, isDate: false, isNumber: false, isString: true},
          {id: 'efectivoActualizacion', name:'Efectivo Actualizacion', isShow: true, isDate: false, isNumber: true, isString: false},
          {id: 'acumuladoCoste', name:'Acumulado Coste', isShow: true, isDate: false, isNumber: true, isString: false},
          {id: 'coste', name:'Coste', isShow: true, isDate: false, isNumber: true, isString: false},
          {id: 'swap', name:'Swap', isShow: false, isDate: false, isNumber: true, isString: false},
          ]

       displayedColumns: string[] = [
        'ncompanias',
        'fechavalor',
        'beneficioacumulado',
        'valorlatente',
        'comision',
        'efectivo',
        'gastosPrestamoAcumulado',
        'gastosGestionAcumulado',
        'valorliquidativo',
        'intervalosinnuevomaximo',
        'retrocesodesdemaximos',
    ];

    displayedColumnsLat: string[] = [
      'numlinea', 'fechaentrada','isooper','compania','precioentrada','cantidadacciones','fechaintervalo','fechainicialintervalo',
      'preciocierre','valorlatente','bajista','efectivoActualizacion','acumuladoCoste','coste'
  ];


  ngOnInit(): void {
    this.valoresliqsubscription = this.controlService.valoresliquidativos$.pipe(auditTime(300)).subscribe({
        next: (data: any)=>{
            this.combinedData = this.flattenArray(data);
            this.combinedData = this.updateCounter(this.combinedData);
            this.liqval.data = this.combinedData;
            
        }
    });
    this.fechaSubcription = this.controlService.valFechaFiltro$.subscribe({
      next: (data: any)=>{
        this.scrollToFirstDate(data);
      }
    });
    //--------------------DIVERSIFICADOR-----------------
    this.divvaloresliqsubscription = this.diversificadorsv.valDivValLiq$.pipe(auditTime(300)).subscribe({
      next: (data: any)=>{
        let combinedata = this.flattenArray(data);
        combinedata = this.updateCounter(combinedata);
        this.Divliqval.data = combinedata;
      }
   });
   this.divfechaSubcription = this.diversificadorsv.valDivFechaFiltro$.subscribe({
      next: (data: any)=>{
        this.scrollToFirstDate(data);
      }
   });
   //-------------------- GESTOR ------------------------
   this.gestFechaSubcription = this._gestorsv.valGestFechaFiltro$.subscribe({
    next: (data: any)=>{
      this.scrollToFirstDate(data);
    }
   });
   this.gestLiqValSub = this._gestorsv.valGestValLiq$.pipe(auditTime(300)).subscribe({
    next: (data: any)=>{
      let combinedata = this.flattenArray(data);
      combinedata = this.updateCounter(combinedata);

      this.gestLiqval.data = combinedata;
    }
   });
   //--------------------BROKER ------------------------
   this.brokFechaSubcription = this._brokersv.valBrokFechaFiltro$.subscribe({
    next: (data: any)=>{
      this.scrollToFirstDate(data);
    }
   });
   this.brokLiqValSub = this._brokersv.valBrokValLiq$.pipe(auditTime(300)).subscribe({
    next: (data: any)=>{
      let combinedata = this.flattenArray(data);
      combinedata = this.updateCounter(combinedata);
      this.brokLiqval.data = combinedata;
    }
   });
  }


  flattenArray(arrayOfArrays: any[]): any[] {
    
    return arrayOfArrays.flatMap(innerArray => innerArray);
  }

  // Numera sobre el propio objeto: copiar todas las filas en cada lote del SSE era coste
  // cuadrático. Solo esta tabla consume estos streams.
  updateCounter(data: valorliquidativointerface[]): valorliquidativointerface[] {
    this.contadorFilas = -1; // Reinicia el contador del lote
    data.forEach((item: any) => {
      item.numlineas = ++this.contadorFilas;
    });
    return data;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.selectedTab === 2){
      //console.log("estamos en liquidating values");
      this.actualizarViewport();
      if(this.modelo){
        if (this.index !== -1) {
          this.viewportLiqVal.scrollToIndex(this.index);
        }
      }else if(this.isPlanificador){
        if (this.indexDiv !== -1) {
          this.viewportLiqValDiv.scrollToIndex(this.indexDiv);
        }
      }else if(this.isGestion){
        if (this.indexGest !== -1) {
          this.viewportLiqValGest.scrollToIndex(this.indexGest);
        }
      }else if(this.isBroker){
        if (this.indexBrok !== -1) {
          this.viewportLiqValBrok.scrollToIndex(this.indexBrok);
        }
      }

    }

 }

    startResizing(event: MouseEvent, column: HTMLElement) {
      // Verificar si el elemento objetivo es el div deseado
      if (column.tagName === 'DIV') {
        const initialY = event.clientY;
        const initialHeigt = column.offsetHeight;
        const mouseMoveListener = (mouseEvent: MouseEvent) => {
          const heightDifference = mouseEvent.clientY - initialY;
          const height = initialHeigt + heightDifference;
          column.style.height = height + 'px';
          if(column.id === 'fila1'){
            const wrapper = column.querySelector('.wrapper') as HTMLElement;
            const initialWrapperHeight = wrapper.offsetHeight;
            console.log(initialWrapperHeight);
           // wrapper.style.height = (initialWrapperHeight + heightDifference) + 'px';
           wrapper.style.height = height +'px';
          }else if(column.id === 'fila2'){
            const wrapper = column.querySelector('.wrapper2') as HTMLElement;
            const initialWrapperHeight = wrapper.offsetHeight;
          //  wrapper.style.height = (initialWrapperHeight + heightDifference) + 'px';
          wrapper.style.height = height +'px';
          }
          
        };
  
        const mouseUpListener = () => {
          document.removeEventListener('mousemove', mouseMoveListener);
          document.removeEventListener('mouseup', mouseUpListener);
        };
  
        document.addEventListener('mousemove', mouseMoveListener);
        document.addEventListener('mouseup', mouseUpListener);
      }
    }

    toggleColumnVisibility(id: any){
        const column = this.tableColumns.find(col => col.id === id);
        if (column) {
          column.isShow = !column.isShow;
          this.displayedColumns = this.tableColumns.filter(col => col.isShow).map(col => col.id);
        }
      }

    toggleColumnLatVisibility(id: any){
      const column = this.tableColumnsLat.find(col => col.id === id);
      if (column) {
        column.isShow = !column.isShow;
        this.displayedColumnsLat = this.tableColumnsLat.filter(col => col.isShow).map(col => col.id);
      }
    }

    actualizarViewport() {
      if(this.modelo){
        if (this.viewportLiqVal) {
          this.viewportLiqVal.checkViewportSize();
          this.viewportLiqVal.checkViewportSize();
        }
      }else if(this.isPlanificador){
        if(this.viewportLiqValDiv){
          this.viewportLiqValDiv.checkViewportSize();
          this.viewportLiqValDiv.checkViewportSize();
        }
      }else if(this.isGestion){
        if(this.viewportLiqValGest){
          this.viewportLiqValGest.checkViewportSize();
          this.viewportLiqValGest.checkViewportSize();
        }
      }else if(this.isBroker){
        if(this.viewportLiqValBrok){
          this.viewportLiqValBrok.checkViewportSize();
          this.viewportLiqValBrok.checkViewportSize();
        }
      }
      }

  scrollToFirstDate(date: string) {
        if(this.modelo){
          this.index = this.liqval.data.findIndex(item => item.fechavalor === date); 
        } 
        else if(this.isPlanificador){
          this.indexDiv=this.Divliqval.data.findIndex(item => item.fechavalor === date);
        }
        else if(this.isGestion){
          this.indexGest = this.gestLiqval.data.findIndex(item => item.fechavalor === date);
        }  
        else if(this.isBroker){
          this.indexBrok = this.brokLiqval.data.findIndex(item => item.fechavalor === date);
        }
        console.log("fecha: ",date);
        console.log("indice: liqval ",this.index);

      }

  selectRow(row: any){
    this.filaSeleccionada=row;
    if(this.modelo){this.controlService.updateFechaFiltro(this.filaSeleccionada.fechavalor);}
    if(this.isPlanificador){this.diversificadorsv.updateDivFechaFiltro(this.filaSeleccionada.fechavalor);}
    if(this.isGestion){this._gestorsv.updategestFechaFiltro(this.filaSeleccionada.fechavalor);}    
    if(this.isBroker){this._brokersv.updateBrokFechaFiltro(this.filaSeleccionada.fechavalor);}   
    }
      

    ngOnDestroy() {
      this.valoresliqsubscription.unsubscribe();
      this.divvaloresliqsubscription.unsubscribe();
      this.fechaSubcription.unsubscribe();
      this.divfechaSubcription.unsubscribe();
      this.gestFechaSubcription.unsubscribe();
      this.gestLiqValSub.unsubscribe();
      this.brokFechaSubcription.unsubscribe();
      this.brokLiqValSub.unsubscribe();
    }
    mostrarFechaScroll(index: any){
      //console.log(index)
      const intIndex = Math.floor(index+5);
      //console.log('Índice entero:', intIndex);
      let item = null;
      if(this.modelo)
      item = this.liqval.data[intIndex];
      if(this.isGestion)
        item = this.gestLiqval.data[intIndex];
      if(this.isBroker)
        item = this.brokLiqval.data[intIndex];
      if(this.isPlanificador)
        item = this.Divliqval.data[intIndex];
      //console.log("item item", item)
      if (item && item.fechavalor) {
        this.currentDate = item.fechavalor;
        //console.log("item currentDate", this.currentDate);
        setTimeout(() => {
          this.currentDate = '';
        }, 10000);
      }
    }
}
